import cx from 'classnames'
import { Node } from 'prosemirror-model'

import Styles from './CondensedTOC.module.scss'
import { ExpandedTOC } from './ExpandedTOC'
import { SUPPORTED_HEADING_LEVELS } from './constants'
import { useActiveHeadingIndex } from './useActiveHeadingIndex'
import { useDocHeadings } from './useDocHeadings'

const HeadingWidths: { [level in typeof SUPPORTED_HEADING_LEVELS[number]]: number } = {
  1: 16,
  2: 14,
  3: 11,
  4: 6,
}

const TOC_LINE_HEIGHT = 2
const TOC_LINE_MARGIN = 20

export const CondensedTOC = () => {
  const activeHeadingIndex = useActiveHeadingIndex()

  const headingNodes = useDocHeadings()

  const tocContent = headingNodes.reduce(
    (ak, node) => [...ak, [node, HeadingWidths[node.attrs.level as keyof typeof HeadingWidths]]] as [Node, number][],
    [] as [Node, number][],
  )

  return (
    <>
      <div className={Styles.condensedToc}>
        <svg
          className={Styles.toc}
          height={Math.max(0, tocContent.length * (TOC_LINE_HEIGHT + TOC_LINE_MARGIN) - TOC_LINE_MARGIN)}
          width="24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {tocContent.map(([heading, width], index) => (
            <rect
              className={cx({ [Styles.active]: activeHeadingIndex === index })}
              height={TOC_LINE_HEIGHT}
              key={`${heading.attrs.blockId}+${index}`}
              width={width}
              x="8"
              y={index * TOC_LINE_MARGIN + index * TOC_LINE_HEIGHT}
            >
              <title>{heading.textContent}</title>
            </rect>
          ))}
        </svg>
      </div>

      <div className={Styles.expandedTocContainer}>
        <div className={Styles.expandedToc}>
          <ExpandedTOC />
        </div>
      </div>
    </>
  )
}
